<template>
    <v-tooltip top open-delay='200'>
      <template v-slot:activator='{ on }'>
        <div v-on='on' class='d-inline-block'>
          <v-chip
            :small='!xSmall'
            :x-small='xSmall'
            label
            color='error'
            :class="left ? 'mr-2' : ''"
          >
            <v-icon
              :small='!xSmall'
              :x-small='xSmall'
              left
            >
                mdi-parking
            </v-icon>
            Parked
          </v-chip>
        </div>
      </template>
      This WO has been parked
    </v-tooltip>
</template>
<script>
  export default {
    name: 'parked-status-chip',
    props: {
      xSmall: {
        required: false,
        type: Boolean,
        default: false
      },
      left: {
        required: false,
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  